import styled, { createGlobalStyle, css } from 'styled-components';

export const lightTheme = {
    primary: '#8C52FF',
    shade1: '#eee',
    color: '#231440',
    background: '#fff',
    shade2: 'rgba(140, 82, 255, 0.25)',
};

export const darkTheme = {
    primary: '#8C52FF',
    shade1: '#333',
    color: '#fff',
    background: '#222',
    shade2: 'rgba(140, 82, 255, 0.5)',
};

const borderConfig = (theme) => `1px solid ${theme.shade1}`;

const flexCenter = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding:  0;
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
    }

    body {
        color: ${({ theme }) => theme.color};
        background: ${({ theme }) => theme.background};
        font-family: Poppins, sans-serif;
    }


    ::selection {
        background: ${({ theme }) => theme.shade2};
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: 600;
        line-height: 1.5;
    }

    p {
        line-height: 1.8;
    }

    button {
        padding: 0;
        border: none;
        outline: none;
    }
`;

export const Layout = styled.main`
    margin: 0 auto;
    max-width: 45em;
    min-height: calc(100vh - 4em);
    padding: 1.5rem;
`;

export const Container = styled.div`
    display: ${({ flex }) => flex && 'flex'};
    justify-content: ${({ justify }) => justify && justify};
    align-items: ${({ align }) => align && align};
    margin: ${({ margin }) => margin && margin};
    width: ${({ fullWidth }) => fullWidth && '100%'};
    height: ${({ height }) => height && height};
    padding: ${({ height }) => (height ? '0 1.5rem' : '1.5rem')};
    padding: ${({ noPadding }) => noPadding && 0};
    background: ${({ theme }) => theme.background};
    border: ${({ border }) => border && borderConfig};
    border-bottom: ${({ borderBottom, theme }) =>
        borderBottom && borderConfig(theme)};
`;

export const Heading1 = styled.h1`
    font-size: 2.25rem;
    color: ${({ theme }) => theme.color};
    margin-left: ${({ marginLeft }) => marginLeft && marginLeft};
    margin-top: ${({ marginTop }) => marginTop && marginTop};
    margin-bottom: ${({ marginBottom }) => marginBottom && marginBottom};

    &::after {
        ${({ dot }) =>
            dot &&
            css`
                content: '.';
                color: ${({ theme }) => theme.primary};
            `}
    }
`;

export const Heading2 = styled(Heading1)`
    font-size: 1.75rem;
`;

export const Paragraph = styled.p`
    font-size: ${({ small }) => (small ? '0.8rem' : '1rem')};
    margin-top: ${({ small }) => small && '1.5rem'};
    margin-bottom: ${({ marginBottom }) => marginBottom && marginBottom};
    text-align: ${({ center }) => center && 'center'};
`;

export const Button = styled.button`
    ${flexCenter}
    margin: 1rem 0;

    padding: 0 2rem;
    width: ${({ fullWidth }) => fullWidth && '100%'};
    height: 3rem;
    border-radius: 100rem;
    outline: none;
    color: ${({ secondary, theme }) => (secondary ? theme.color : '#fff')};
    background: ${({ secondary, theme }) =>
        secondary ? theme.shade1 : theme.primary};
    font-size: 1rem;
    font-weight: 500;
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;

    transition: all 0.3s ease;

    &:hover,
    &:focus {
        background: ${({ secondary, theme }) => secondary && theme.background};
        box-shadow: 0 0 0 0.3em ${({ theme }) => theme.shade2};
    }
`;

export const IconButton = styled.button`
    ${flexCenter};
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 50%;
    outline: none;
    color: ${({ theme }) => theme.primary};
    background: ${({ theme }) => theme.shade1};
    cursor: pointer;

    transition: all 0.3s ease;

    &:hover {
        color: ${({ theme }) => theme.background};
        background: ${({ theme }) => theme.primary};
    }
`;

export const ProfilePic = styled.img`
    height: 7em;
    width: 7em;
    border-radius: 50%;
`;
